import { Route, Routes } from "react-router";
import { PageNotFound } from "../components/pageNotFound";

import { CategoriesPage } from "../pages/categories/containers";
import { Home } from "../pages/home/container";
import { Login } from "../pages/login";
import { News } from "../pages/news";
import { AdminNoticias } from "../pages/private/adminNoticias";
import { Post } from "../pages/private/posts";

export const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/login/" element={<Login />} />
      <Route path="/parceiros" element={<CategoriesPage />} />
      <Route path="/noticia/delete" element={<AdminNoticias />} />
      <Route path="/noticia/post" element={<Post />} />
      <Route path="/noticia/:slug" element={<News />} />
      <Route
        path="/parceiros/categoria/:category"
        element={<CategoriesPage />}
      />
      <Route path="/*" element={<PageNotFound isPageNotFound />} />
    </Routes>
  );
};
